import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  animations: [slide]
})
export class EventListComponent implements OnInit {
  events:  FirebaseListObservable<any[]>;
  selectedEvent: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private dbService: DBService
  ) {

    this.events = this.dbService.getEvents();

  }

  ngOnInit() {
  }

  showEvent(key: string) {
    this.router.navigate([`/calendar/${key}`]);
  }


  onAddClicked() {
    this.selectedEvent = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onEditClicked(event, mouseEvent) {
    mouseEvent.stopPropagation();
    this.selectedEvent = event;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked(event, mouseEvent) {
    mouseEvent.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedEvent = event;
  }

  onConfirmDelete() {
    this.onHideDeleteModal();
    this.dbService.deleteEvent(this.selectedEvent.$key);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/calendar/event-list/event-list.component.ts